var _Circle, _Circle2, _Path, _Circle3, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgRecoveryAccess = function SvgRecoveryAccess(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 30,
    cy: 30,
    r: 28,
    fill: "white",
    stroke: "#F74249",
    strokeWidth: 4
  })), _Circle2 || (_Circle2 = /*#__PURE__*/React.createElement(Circle, {
    cx: 30,
    cy: 23,
    r: 7,
    fill: "#F7931A"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.707 36.83A6.028 6.028 0 0 1 24.32 33h11.36c2.48 0 4.707 1.52 5.612 3.83 1.162 2.965-1.025 6.17-4.21 6.17H22.917c-3.185 0-5.372-3.205-4.21-6.17Z",
    fill: "#494949"
  })), _Circle3 || (_Circle3 = /*#__PURE__*/React.createElement(Circle, {
    cx: 48,
    cy: 48,
    r: 12,
    fill: "#37CC33"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 48.119c0-3.849-3.152-7-7-7V38.5l-3.479 3.52 3.48 3.479v-2.62a5.224 5.224 0 0 1 5.239 5.24c0 .9-.205 1.72-.614 2.456l1.269 1.269A6.861 6.861 0 0 0 55 48.119Zm-7 2.62v2.618a5.224 5.224 0 0 1-5.24-5.24c0-.9.205-1.718.614-2.456l-1.269-1.268A6.862 6.862 0 0 0 41 48.118c0 3.848 3.152 7 7 7v2.62l3.479-3.52-3.48-3.48Z",
    fill: "white"
  })));
};
export default SvgRecoveryAccess;